/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProActiveGovernanceScannerMasterDetail extends models.ScannerRuleBase {
    getFixupPrototypeFunction() { return ProActiveGovernanceScannerMasterDetail.fixupPrototype; }

    static newInstance(model: Partial<ProActiveGovernanceScannerMasterDetail>): ProActiveGovernanceScannerMasterDetail {
        let obj = Object.assign(new ProActiveGovernanceScannerMasterDetail(), model);
        ProActiveGovernanceScannerMasterDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProActiveGovernanceScannerMasterDetail>): ProActiveGovernanceScannerMasterDetail {
        if (!model) return null;
        return ProActiveGovernanceScannerMasterDetail.newInstance(<ProActiveGovernanceScannerMasterDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProActiveGovernanceScannerMasterDetail) {
        if (!obj) return;

        models.ProActiveGovernanceScannerMasterDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProActiveGovernanceScannerMasterDetail): boolean {
        if (models.ScannerRuleBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProActiveGovernanceScannerMasterDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Classification of the policy
     */
    classification: models.PolicyClassification;

    /**
     * reference id for the rule which will be used in engine
     */
    reference_id: string;

    /**
     * Source for the scanner.
     */
    source: models.GovernanceScannerSource;

    /**
     * A Boolean Field which represents whether the rule is being scanned is global or not.
     */
    is_global: boolean = false;

    /**
     * The Attribute which will be used while posting the comment for a finding.
     */
    output_attribute: string;

    /**
     * The default output message which will append with the finding for each configuration.
     */
    default_output_message: string;

    /**
     * Name of the resource type which will be used in checkov
     */
    scanner_resource_type: string;

}
